export default "__VITE_ASSET__Bmk6MlLg__"